import { PerformanceReviewEvaluationStatusEnum } from 'generated/resources/graphql'

import { i18nDateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

export const getEvaluationDateLabel = ({
  status,
  publishedAt,
  republishedAt,
  endsAt,
}: {
  status: PerformanceReviewEvaluationStatusEnum
  publishedAt?: string | null
  republishedAt?: string | null
  endsAt?: string | null
}): string => {
  const noDataLabel = i18n.t('performance_process.insights.no_data')

  if (status === 'published') {
    if (republishedAt) {
      return i18n.t('performance_process.reviews.answer_evaluation.actions.republished_on', {
        date: i18nDateToString(new Date(republishedAt), 'ui'),
      })
    }

    if (publishedAt) {
      return i18n.t('performance_process.reviews.answer_evaluation.actions.published_on', {
        date: i18nDateToString(new Date(publishedAt), 'ui'),
      })
    }

    return `${i18n.t(
      'performance_process.reviews.answer_evaluation.answer_status.published'
    )}: ${noDataLabel}`
  }

  const dueDateLabel = i18n.t('performance_process.reviews.common.due_date')
  return endsAt
    ? `${dueDateLabel} ${i18nDateToString(new Date(endsAt), 'ui')}`
    : `${dueDateLabel}: ${noDataLabel}`
}
